import React, { Component } from "react";

import ModalMedia from "./modal/modal_media";

import Media from "./media/media";

class ListMedia extends Component {
  state = { openMedia: false };
  render() {
    return (
      <React.Fragment>
        <div
          className="media_v2"
          onClick={this.clickMedia}
          style={{ cursor: "pointer" }}
        >
          <Media answer={this.props.answer} openMedia={false} />
        </div>
        <ModalMedia
          open={this.state.openMedia}
          handleCloseView={this.closeMedia}
          answer={this.props.answer}
        />
      </React.Fragment>
    );
  }

  clickMedia = event => {
    event.preventDefault();
    const openMedia = true;
    this.setState({ openMedia });
  };

  closeMedia = e => {
    const openMedia = false;
    this.setState({ openMedia });
  };
}

export default ListMedia;



// WEBPACK FOOTER //
// ./src/components/list/interface/list_media.jsx